export default "assets/images/icons/chevron-0e0dc4d3.svg";